var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "instagram-contact-list-switcher" },
    [
      _c("LeadList", {
        attrs: {
          channelId: _vm.selectedChannelId,
          channel: _vm.getSelectedChannel(),
          "show-title": false,
          "allow-import": "",
          forbidden: _vm.isForbidden(_vm.getSelectedChannel()),
        },
        scopedSlots: _vm._u([
          {
            key: "left-actions",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "channel-switcher" },
                  [
                    _c("ChannelPicker", {
                      attrs: {
                        "auto-select-first": "",
                        "include-deleted": "",
                        "allowed-types": ["instagram", "instagram-v2"],
                      },
                      model: {
                        value: _vm.selectedChannelId,
                        callback: function ($$v) {
                          _vm.selectedChannelId = $$v
                        },
                        expression: "selectedChannelId",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }